import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
const PIXEL_ID = '1288625290143904';
export function MetaPixel() {
  useEffect(() => {
    try {
      if (typeof window === 'undefined' || typeof document === 'undefined') return;
      // Standard Meta Pixel bootstrap snippet — only inject if not already present
      if (!window.fbq) {
        const n: any = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        window.fbq = n;
        if (!window._fbq) window._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = document.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const s = document.getElementsByTagName('script')[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          document.head.appendChild(t);
        }
      }
      // Initialize and fire PageView
      if (typeof window.fbq === 'function') {
        window.fbq('init', PIXEL_ID);
        window.fbq('track', 'PageView');
      }
    } catch (err) {
      // Never let pixel errors break the page
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  return <noscript data-id="element-94">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-95" />
    </noscript>;
}